module.exports = __webpack_public_path__ + "img/award_placeholder.955a41c6.png";